import { render, staticRenderFns } from "./TwoStepCaptcha.vue?vue&type=template&id=798ef406&scoped=true&"
import script from "./TwoStepCaptcha.vue?vue&type=script&lang=js&"
export * from "./TwoStepCaptcha.vue?vue&type=script&lang=js&"
import style0 from "./TwoStepCaptcha.vue?vue&type=style&index=0&id=798ef406&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798ef406",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('798ef406')) {
      api.createRecord('798ef406', component.options)
    } else {
      api.reload('798ef406', component.options)
    }
    module.hot.accept("./TwoStepCaptcha.vue?vue&type=template&id=798ef406&scoped=true&", function () {
      api.rerender('798ef406', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tools/TwoStepCaptcha.vue"
export default component.exports